/// <reference path='../../typings/browser.d.ts' />

namespace Application.Directives {
    'use strict';

    declare type MdInputDirectiveFactoryCb = ($timeout: ng.ITimeoutService,
                                              $compile: ng.ICompileService) => MdInputDirective;

    /**
     * Custom scope
     */
    export interface IMdInputDirectiveScopeDef {
        ngModel: string;
        clearButton: string;
        clearValue: string;
        clearButtonOnlyDirty: string;
    }

    /**
     * Custom scope
     */
    export interface IMdInputDirectiveScope extends ng.IScope {
        ngModel: string;
        clearButton: string;
        clearInput: ($event: ng.IAngularEvent) => void;
        updateInput: () => void;
        clearValue: () => string;
        clearButtonOnlyDirty: string;
    }

    /**
     * MdFabSpeedDialDirective
     */
    export class MdInputDirective implements ng.IDirective {
        public static $name: string = 'mdInput';

        public link: (scope: IMdInputDirectiveScope, element: JQuery, attrs: ng.IAttributes) => void;
        public restrict: string = 'A';
        public transclude: boolean = false;
        public scope: IMdInputDirectiveScopeDef = {
            ngModel: '=',
            clearButton: '@?',
            clearValue: '&',
            clearButtonOnlyDirty: '@?',
        };

        public static Factory(): MdInputDirectiveFactoryCb {
            let directive: MdInputDirectiveFactoryCb = ($timeout: ng.ITimeoutService, $compile: ng.ICompileService) => {
                return new MdInputDirective($timeout, $compile);
            };
            directive.$inject = ['$timeout', '$compile'];
            return directive;
        }

        public static updateInput(element: JQuery, scope: IMdInputDirectiveScope, $compile: ng.ICompileService): void {
            let $elem: JQuery = $(element);
            // clear wrapper classes
            $elem.closest('.md-input-wrapper')
                    .removeClass('md-input-wrapper-danger md-input-wrapper-success md-input-wrapper-disabled');

            if (scope !== undefined && !!scope.clearButton) {
                $elem.parent().find('.md-input-clear').remove();
                if ($elem.val() !== '' && (scope.clearButtonOnlyDirty === undefined || scope.clearButtonOnlyDirty === "true")) {
                    $elem.closest('.md-input-wrapper').addClass('md-input-filled');
                    let close: JQuery = angular.element(`<div class='md-input-clear' ng-mousedown='clearInput()'>
                                                           <i class='material-icons uk-text-muted cursor-pointer'>clear</i>
                                                         </div>`);
                    $compile(close)(scope);
                    if($elem.parent().hasClass("md-input-wrapper")) {
                        $elem.parent().append(close);
                    }
                }
            }

            if ($elem.hasClass('md-input-danger')) {
                $elem.closest('.md-input-wrapper').addClass('md-input-wrapper-danger');
            }
            if ($elem.hasClass('md-input-success')) {
                $elem.closest('.md-input-wrapper').addClass('md-input-wrapper-success');
            }
            if ($elem.prop('disabled')) {
                $elem.closest('.md-input-wrapper').addClass('md-input-wrapper-disabled');
            }
            if ($elem.hasClass('label-fixed')) {
                $elem.closest('.md-input-wrapper').addClass('md-input-filled');
            }
            if ($elem.val() !== '') {
                $elem.closest('.md-input-wrapper').addClass('md-input-filled');
            }

        }

        /**
         * Constructor
         */
        constructor($timeout: ng.ITimeoutService, $compile: ng.ICompileService) {
            MdInputDirective.prototype.link = (scope: IMdInputDirectiveScope, element: JQuery, attrs: ng.IAttributes) => {
                let $elem: JQuery = $(element);

                $elem.addClass('md-input');

                scope.updateInput = function(): void {
                    MdInputDirective.updateInput(element, scope, $compile);
                };

                scope.clearInput = function(): void {
                    $timeout(() => {
                        if (scope.clearValue) {
                            scope.ngModel = scope.clearValue();
                        } else {
                            scope.ngModel = '';
                        }
                        scope.updateInput();
                        $timeout(() => {
                            $($elem).blur();
                        }, 100);
                    });
                };

                $timeout(() => {
                    if (!$elem.hasClass('md-input-processed')) {
                        let extraClass: string = '';
                        if ($elem.is('[class*="uk-form-width-"]')) {
                            let elClasses: string[] = $elem.attr('class').split (' ');
                            for (let i: number = 0; i < elClasses.length; i++) {
                                let classPart: string = elClasses[i].substr(0, 14);
                                if (classPart === 'uk-form-width-') {
                                    extraClass = elClasses[i];
                                }
                            }
                        }

                        if ($elem.prev('label').length) {
                            $elem.prev('label').addBack().wrapAll('<div class="md-input-wrapper"/>');
                        } else if ($elem.siblings('[data-uk-form-password]').length) {
                            $elem.siblings('[data-uk-form-password]').addBack().wrapAll('<div class="md-input-wrapper"/>');
                        } else {
                            $elem.wrap('<div class="md-input-wrapper"/>');
                        }
                        $elem.addClass('md-input-processed')
                             .closest('.md-input-wrapper')
                             .append(`<span class='md-input-bar ${extraClass}'/>`);
                    }
                    scope.updateInput();
                });

                scope.$watch(() => { return $elem.attr('class'); }, (newValue: string, oldValue: string) => {
                    if (newValue !== oldValue) {
                        scope.updateInput();
                    }
                });

                scope.$watch(() => { return $elem.val(); }, (newValue: string, oldValue: string) => {
                    if (newValue !== oldValue) {
                        scope.updateInput();
                    }
                });

                $elem
                    .on('focus', () => {
                        $elem.closest('.md-input-wrapper').addClass('md-input-focus');
                    })
                    .on('blur', () => {
                        $elem.closest('.md-input-wrapper').removeClass('md-input-focus');
                        if ($elem.val() === '' && !$elem.hasClass('label-fixed')) {
                            $elem.closest('.md-input-wrapper').removeClass('md-input-filled');
                        } else {
                            $elem.closest('.md-input-wrapper').addClass('md-input-filled');
                        }
                    });

                scope.$on('$destroy', () => {
                    $elem.off('focus');
                    $elem.off('blur');
                });
            };
        }
    }
}